var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{class:{scrolled: _vm.scrollPosition > 96},attrs:{"id":"mainMenu"}},[_c('header-component')],1),_c('div',{attrs:{"id":"mainContent"}},[_c('router-view',{key:_vm.$route.path})],1)]),_c('browser-check')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }